import { useSelector } from 'react-redux'

import { smsLegalDisclaimerSelector, smsReminderEnabledSelector } from 'selectors/event_type'

export const SmsLegalDisclaimer = (props) => {
  const smsReminderEnabled = useSelector(smsReminderEnabledSelector)
  const smsLegalDisclaimerText = useSelector(smsLegalDisclaimerSelector)

  if (!smsReminderEnabled || !smsLegalDisclaimerText) {
    return null
  }

  return (
    <div {...props} data-component="sms-legal-disclaimer">{smsLegalDisclaimerText}</div>
  )
}
